import React from "react"
import styled from "styled-components"
import Box from "../../lib/ui/ui-box"
import Logo from "../logo"

const Root = styled(Box)`
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  padding-bottom: 90px;
`

const BankIcon = styled.img`
  max-width:120px;
  margin-top:32px;
`

export default props => {
  return (
    <Root
      flexDirection="row"
      align="center"
      w={[1]}
      mx={["auto"]}
      maxWidth="1200px"
      justify="space-between"
      flexDirection={["column", "row"]}
      pt={["100px", "150px"]}
    >
      <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
      <BankIcon src="/images/banks/EquitableBank.png" alt="Bank Icon" />
    </Root>
  )
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.component.js